var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.086,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311b92",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311b92",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.032,
    cy: 0.027,
    r: 1.612,
    gradientTransform: "translate(0 0.007) scale(1 0.727)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133155",
    "data-name": "Group 133155",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30696",
    "data-name": "Rectangle 30696",
    width: 28,
    height: 28,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forms-icon",
    transform: "translate(4.936 0.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.83,0H1.774A1.78,1.78,0,0,0,0,1.774V24.251a1.78,1.78,0,0,0,1.774,1.774H17.153a1.78,1.78,0,0,0,1.774-1.774V7.1L14.787,4.14Z",
    fill: "#673ab7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-2",
    "data-name": "Clipped",
    transform: "translate(4.412 12.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.364,39.233H20.9V38.044h-6.54Zm0-7.134v1.189H20.9V32.1Zm-1.486.595a.892.892,0,1,1-.892-.892A.892.892,0,0,1,12.877,32.694Zm0,2.973a.892.892,0,1,1-.892-.892A.892.892,0,0,1,12.877,35.666Zm0,2.973a.892.892,0,1,1-.892-.892A.892.892,0,0,1,12.877,38.639Zm1.486-2.378H20.9V35.072h-6.54Z",
    transform: "translate(-11.094 -31.802)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-3",
    "data-name": "Clipped",
    transform: "translate(12.315 6.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M30.881,16.452l6.612,6.611V16.974Z",
    transform: "translate(-30.881 -16.452)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-4",
    "data-name": "Clipped",
    transform: "translate(11.794 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133128",
    "data-name": "Group 133128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M2.958,2.958V8.309a1.783,1.783,0,0,0,1.784,1.784h5.351Z",
    transform: "translate(-2.958 -2.958)",
    fill: "#b39ddb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-5",
    "data-name": "Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M1.784,0A1.789,1.789,0,0,0,0,1.784v.149A1.789,1.789,0,0,1,1.784.149H11.89V0Z",
    fill: "rgba(255,255,255,0.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-6",
    "data-name": "Clipped",
    transform: "translate(0 24.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M17.153,62.06H1.774A1.784,1.784,0,0,1,0,60.276v.149a1.784,1.784,0,0,0,1.774,1.784H17.153a1.784,1.784,0,0,0,1.774-1.784v-.149A1.784,1.784,0,0,1,17.153,62.06Z",
    transform: "translate(0 -60.276)",
    fill: "rgba(49,27,146,0.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-7",
    "data-name": "Clipped",
    transform: "translate(11.794 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M31.367,15.1a1.783,1.783,0,0,1-1.784-1.784v.149a1.783,1.783,0,0,0,1.784,1.784h5.351V15.1Z",
    transform: "translate(-29.583 -13.313)",
    fill: "rgba(49,27,146,0.1)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M11.83,0H1.774A1.78,1.78,0,0,0,0,1.774V24.251a1.78,1.78,0,0,0,1.774,1.774H17.153a1.78,1.78,0,0,0,1.774-1.774V7.1Z",
    fill: "url(#radial-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleForms);
export default __webpack_public_path__ + "static/media/google_forms.44b752fe5aa4a4e1e80296231f079157.svg";
export { ForwardRef as ReactComponent };